'use client';

import { useContext, useEffect } from 'react';
import { UserContext } from '@/_contexts/UserProvider';
import * as Sentry from '@sentry/nextjs';

export default function ErrorPage({
  error,
}: {
  error: Error & { digest?: string; status?: number };
}) {
  const { signOut } = useContext(UserContext);

  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  if (error?.status === 401) {
    return signOut();
  }

  return (
    <div>
      <h2>Something went wrong!</h2>
    </div>
  );
}
